import { useEffect, useState } from "react";
import { ImageBroken } from "@phosphor-icons/react";

export const SafeRecipeImage = ({ src, alt, className = "", fallback, onFailure, testId }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return fallback || (
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 text-[hsl(var(--muted-foreground))]" data-testid={testId ? `${testId}-fallback` : undefined}>
        <ImageBroken size={36} weight="thin" />
        <span className="text-xs">Portada no disponible</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      data-testid={testId}
      onError={() => {
        setFailed(true);
        onFailure?.();
      }}
    />
  );
};